import React from 'react';
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface HomeLinkProps {
  variant?: 'body1' | 'body2' | 'caption' | 'subtitle1' | 'subtitle2';
}

const HomeLink: React.FC<HomeLinkProps> = ({ variant = 'body1' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <Link
      component='button'
      variant={variant}
      onClick={handleClick}
      sx={{
        textDecoration: 'underline',
        color: 'secondary.main',
        verticalAlign: 'baseline',
      }}
    >
      {t('apiDetail.mainPage')}
    </Link>
  );
};

export default HomeLink;
